export interface AnimeItem {
  id: string;
  title: string;
  coverImage: string;
  description: string;
  category: '日漫' | '韩漫' | '国漫';
  rating: number;
  episodes: number;
  status: '连载中' | '已完结';
  tags: string[];
  author: string;
  year: number;
  views: string;
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
}

export const animeList: AnimeItem[] = [
  {
    id: 'kimetsu-no-yaiba',
    title: '鬼灭之刃',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20of%20a%20young%20swordsman%20with%20dark%20red%20hair%20and%20green%20checkered%20haori%20holding%20a%20katana%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20Japanese%20anime%20art%20style%2C%20clean%20composition%2C%20dark%20background%20with%20flame%20effects&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。母亲与四个弟妹惨遭杀害，而与他一起生还的妹妹祢豆子亦异变成凶暴的鬼。在猎鬼人的指引下，立志成为猎鬼人的炭治郎与变成鬼却尚存理智的祢豆子踏上了旅程。',
    category: '日漫',
    rating: 9.8,
    episodes: 44,
    status: '已完结',
    tags: ['热血', '战斗', '奇幻', '少年'],
    author: '吾峠呼世晴',
    year: 2019,
    views: '12.8亿',
    updatedAt: '2024-06-30',
    isHot: true,
    isNew: false,
  },
  {
    id: 'jujutsu-kaisen',
    title: '咒术回战',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20teenage%20boy%20with%20spiky%20pink%20hair%20wearing%20a%20dark%20uniform%2C%20surrounded%20by%20cursed%20energy%20effects%2C%20dynamic%20pose%2C%20Japanese%20anime%20illustration%20style%2C%20purple%20and%20black%20color%20scheme&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    description: '少年战斗着——「为寻求正确的死亡」。辛酸、后悔、耻辱，人类产生的负面情感，化为诅咒，潜伏于日常生活。诅咒是蔓延于世界的祸源，最糟糕的情况下，会让人类踏入死亡。并且，诅咒只能以诅咒祓除。拥有惊人身体能力的少年·虎杖悠仁原本过着普通的高中生活。某天，为了拯救被"诅咒"袭击的同伴，他吞下了特级咒物"两面宿傩之指"，让诅咒寄宿于自己的灵魂之中。',
    category: '日漫',
    rating: 9.7,
    episodes: 48,
    status: '连载中',
    tags: ['热血', '战斗', '超能力', '校园'],
    author: '芥见下下',
    year: 2020,
    views: '15.2亿',
    updatedAt: '2024-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'one-piece',
    title: '海贼王',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20young%20pirate%20with%20straw%20hat%20and%20red%20vest%2C%20fist%20raised%2C%20ocean%20background%20with%20pirate%20ship%2C%20adventure%20theme%2C%20bright%20and%20vibrant%20Japanese%20anime%20style&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    description: '传奇海盗哥尔·D·罗杰在临死前曾留下关于其毕生的财富"One Piece"的消息，由此引得群雄并起，众海盗们为了这笔传说中的巨额财富展开争夺，各种势力、政权不断交替，整个世界进入了动荡混乱的"大海贼时代"。生长在东海某小村庄的路飞受到海贼香克斯的精神指引，决定成为一名出色的海盗。为了达成这个目标，并找到万众瞩目的One Piece，路飞踏上艰苦的旅程。',
    category: '日漫',
    rating: 9.9,
    episodes: 1100,
    status: '连载中',
    tags: ['热血', '冒险', '友情', '战斗'],
    author: '尾田荣一郎',
    year: 1999,
    views: '50.6亿',
    updatedAt: '2024-08-03',
    isHot: true,
    isNew: false,
  },
  {
    id: 'dong-fang-xian-yun',
    title: '东方纤云',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20poster%20of%20a%20young%20cultivator%20in%20flowing%20white%20and%20blue%20robes%2C%20floating%20in%20a%20mythical%20landscape%20with%20clouds%2C%20mountains%2C%20and%20magical%20energy%2C%20elegant%20composition&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    description: '东方纤云是一个普通的现代青年，意外穿越到一个修仙世界后，发现自己拥有了特殊的体质和天赋。在这个充满门派纷争、灵兽横行的世界中，东方纤云凭借自己的智慧和勇气，从一个底层的外门弟子一步步成长为震撼整个修仙界的传奇人物。然而，随着实力的提升，他也逐渐发现了这个世界背后隐藏的巨大秘密。',
    category: '国漫',
    rating: 9.5,
    episodes: 120,
    status: '连载中',
    tags: ['修仙', '穿越', '热血', '玄幻'],
    author: '唐家三少',
    year: 2022,
    views: '8.5亿',
    updatedAt: '2024-08-02',
    isHot: true,
    isNew: false,
  },
  {
    id: 'tian-guan-ci-fu',
    title: '天官赐福',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20of%20two%20elegant%20male%20characters%20in%20traditional%20Chinese%20robes%2C%20one%20in%20white%20and%20one%20in%20red%2C%20cherry%20blossom%20petals%2C%20romantic%20atmosphere%2C%20ethereal%20lighting&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    description: '八百年前，谢怜是金枝玉叶的太子殿下，风光无限的天之骄子。谁知一朝得道飞升，成为万人供奉的武神，却是急转直下，一贬再贬贬无可贬。八百年后，谢怜又双叒飞升了。这一次没有信徒也没有香火，某日收破烂归来的路上，他将一个神秘少年捡回家中，而这少年，居然是一位身份诡秘莫测的三界鬼王。',
    category: '国漫',
    rating: 9.6,
    episodes: 24,
    status: '连载中',
    tags: ['仙侠', '耽美', '玄幻', '爱情'],
    author: '墨香铜臭',
    year: 2023,
    views: '10.2亿',
    updatedAt: '2024-07-28',
    isHot: true,
    isNew: true,
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20poster%20of%20a%20handsome%20dark-haired%20hunter%20with%20glowing%20purple%20eyes%2C%20wearing%20a%20black%20coat%2C%20surrounded%20by%20shadow%20soldiers%2C%20dark%20and%20mysterious%20atmosphere&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    description: '10年前，世界与其他次元链接的"门"被打开，各种魔物不断出现，于是出现了能力各异的猎魔者，被称为"猎人"。程肖宇是一名实力最弱的E级猎人，在一次挑战任务中，遇到了可怕的隐藏挑战。生死存亡之际，他居然获得了升级系统！在系统的利用下，他成为了无与伦比的猎人，但升级背后隐藏着什么样的秘密呢？',
    category: '韩漫',
    rating: 9.9,
    episodes: 179,
    status: '已完结',
    tags: ['热血', '奇幻', '升级', '战斗'],
    author: 'Chugong',
    year: 2024,
    views: '18.3亿',
    updatedAt: '2024-07-15',
    isHot: true,
    isNew: false,
  },
  {
    id: 'spy-family',
    title: '间谍过家家',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20family%20of%20three%20-%20a%20man%20in%20suit%2C%20a%20woman%20with%20red%20hair%2C%20and%20a%20little%20girl%20with%20pink%20hair%2C%20spy%20theme%2C%20warm%20and%20funny%20Japanese%20anime%20style%2C%20pastel%20colors&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    description: '为了潜入名校，西国能力最强的间谍黄昏被下令组建家庭。但是，他的"女儿"居然是能够读取他人内心的超能力者！"妻子"是暗杀者？互相隐藏了真实身份的新家庭，面临考验与世界危机的痛快家庭喜剧就此展开！这个临时组建的家庭，在执行任务的过程中，渐渐产生了真正的亲情。',
    category: '日漫',
    rating: 9.7,
    episodes: 37,
    status: '连载中',
    tags: ['搞笑', '日常', '间谍', '家庭'],
    author: '远藤达哉',
    year: 2022,
    views: '11.5亿',
    updatedAt: '2024-08-01',
    isHot: true,
    isNew: false,
  },
  {
    id: 'quan-zhi-gao-shou',
    title: '全职高手',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20of%20a%20cool%20esports%20player%20with%20silver%20hair%2C%20holding%20a%20gaming%20mouse%2C%20futuristic%20gaming%20background%20with%20holographic%20displays%2C%20dynamic%20action%20pose&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆，和一把未完成的自制武器，开始了重返巅峰之路。',
    category: '国漫',
    rating: 9.6,
    episodes: 36,
    status: '连载中',
    tags: ['电竞', '热血', '竞技', '游戏'],
    author: '蝴蝶蓝',
    year: 2017,
    views: '7.8亿',
    updatedAt: '2024-07-20',
    isHot: false,
    isNew: false,
  },
  {
    id: 'tales-of-demons-and-gods',
    title: '妖神记',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20poster%20of%20a%20young%20boy%20with%20spiritual%20beast%20companion%2C%20ancient%20Chinese%20city%20background%2C%20cultivation%20theme%2C%20magical%20glowing%20effects%2C%20fantasy%20atmosphere&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    description: '妖神重生的聂离，带着前世的记忆和仇恨，回到了自己十三岁的时候。这一世，他发誓要保护好自己的家人和朋友，绝不让前世的悲剧重演。凭借前世的经验和知识，他在修炼道路上突飞猛进，同时也开始布局，一步步瓦解那些隐藏在暗处的敌人，揭开这个世界背后深藏的惊天秘密。',
    category: '国漫',
    rating: 9.3,
    episodes: 200,
    status: '连载中',
    tags: ['重生', '修仙', '热血', '玄幻'],
    author: '发飙的蜗牛',
    year: 2019,
    views: '6.2亿',
    updatedAt: '2024-08-03',
    isHot: false,
    isNew: false,
  },
  {
    id: 'god-of-high-school',
    title: '高校之神',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20poster%20of%20a%20teenage%20martial%20artist%20in%20school%20uniform%2C%20dynamic%20fighting%20pose%2C%20explosive%20energy%20effects%2C%20tournament%20arena%20background%2C%20action-packed%20composition&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    description: '从爷爷那里得到跆拳道真传的陈毛利，得到了"高中之神"的邀请，并在大会中脱颖而出，进入全国争霸赛。但是大会的背后的阴谋和秘密也正在逐步蔓延，一场围绕着"神"的战斗即将展开！各地高手云集，超能力与武术的终极对决，谁能成为真正的"神"？',
    category: '韩漫',
    rating: 9.4,
    episodes: 13,
    status: '已完结',
    tags: ['格斗', '热血', '超能力', '校园'],
    author: '朴溶济',
    year: 2020,
    views: '3.5亿',
    updatedAt: '2024-01-10',
    isHot: false,
    isNew: false,
  },
  {
    id: 'dragon-ball-super',
    title: '龙珠超',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20muscular%20warrior%20with%20spiky%20black%20hair%20in%20orange%20gi%2C%20powering%20up%20with%20blue%20aura%2C%20epic%20battle%20stance%2C%20classic%20Japanese%20anime%20style%2C%20explosive%20energy&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    description: '在魔人布欧之战后，地球迎来了和平时期。然而，破坏神比鲁斯的苏醒打破了这份宁静。为了寻找传说中的超级赛亚人之神，比鲁斯来到了地球。悟空和伙伴们必须面对前所未有的强大敌人，跨越一个又一个的界限，在宇宙的舞台上展开全新的冒险与战斗。',
    category: '日漫',
    rating: 9.5,
    episodes: 131,
    status: '已完结',
    tags: ['热血', '战斗', '冒险', '科幻'],
    author: '鸟山明',
    year: 2015,
    views: '20.1亿',
    updatedAt: '2024-03-25',
    isHot: false,
    isNew: false,
  },
  {
    id: 'the-begining-after-the-end',
    title: '三岁开始做王者',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20poster%20of%20a%20young%20king%20with%20crown%20and%20royal%20robes%2C%20magical%20sword%2C%20fantasy%20kingdom%20background%2C%20reincarnation%20theme%2C%20majestic%20and%20epic%20atmosphere&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    description: '曾经统治整个大陆的最强国王格雷·莱伊冯，在生命终结之际选择了重生。他转世成为了一个名叫亚瑟·雷温的婴儿，保留着前世的全部记忆。在这个充满魔法与剑术的世界里，亚瑟从三岁开始就展现出惊人的天赋，他要在这一世重新攀登巅峰，同时守护那些他珍视的人们。',
    category: '韩漫',
    rating: 9.7,
    episodes: 175,
    status: '连载中',
    tags: ['重生', '奇幻', '魔法', '冒险'],
    author: 'TurtleMe',
    year: 2023,
    views: '9.6亿',
    updatedAt: '2024-08-02',
    isHot: true,
    isNew: true,
  },
  {
    id: 'mo-dao-zu-shi',
    title: '魔道祖师',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20of%20a%20man%20in%20black%20and%20red%20flowing%20robes%20playing%20a%20flute%2C%20haunting%20spirits%20surrounding%20him%2C%20dark%20mystical%20atmosphere%2C%20traditional%20Chinese%20ink%20painting%20style&width=600&height=800&seq=anime-cover-13&orientation=portrait',
    description: '温氏横行，生灵涂炭。江湖仙门义士发动"射日之征"，合力讨伐温氏。"夷陵老祖"魏无羡虽在推翻温氏中立下了汗马功劳，却因修非常道且太过强大而遭人忌惮，被仙门百家设计围剿，最终身陨魂消。十三年后，魏无羡被人献舍重生，并再度与故人蓝忘机相遇，两人一同追查一具被肢解的无名尸体，揭开了尘封多年的惊天秘密。',
    category: '国漫',
    rating: 9.8,
    episodes: 35,
    status: '已完结',
    tags: ['仙侠', '耽美', '悬疑', '玄幻'],
    author: '墨香铜臭',
    year: 2018,
    views: '14.5亿',
    updatedAt: '2024-05-20',
    isHot: false,
    isNew: false,
  },
  {
    id: 'tower-of-god',
    title: '神之塔',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20poster%20of%20a%20boy%20climbing%20a%20mysterious%20tower%2C%20surreal%20fantasy%20floors%20with%20different%20worlds%2C%20water%20and%20light%20effects%2C%20mysterious%20blue%20atmosphere&width=600&height=800&seq=anime-cover-14&orientation=portrait',
    description: '只要登上塔的顶端，就能得到任何想要的东西——财富、荣耀、权力、复仇，甚至神的力量。少女蕾哈尔为了追逐星空而进入神之塔，少年二十五夜为了追寻蕾哈尔也进入了神之塔。在这座神秘的高塔中，每一层都是一个独立的世界，充满了危险的试炼和强大的对手。',
    category: '韩漫',
    rating: 9.5,
    episodes: 13,
    status: '连载中',
    tags: ['奇幻', '冒险', '战斗', '友情'],
    author: 'SIU',
    year: 2024,
    views: '5.8亿',
    updatedAt: '2024-07-30',
    isHot: false,
    isNew: true,
  },
  {
    id: 'attack-on-titan',
    title: '进击的巨人',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20soldiers%20with%20maneuver%20gear%20fighting%20a%20giant%20titan%2C%20post-apocalyptic%20setting%20with%20walls%2C%20dramatic%20and%20dark%20Japanese%20anime%20style%2C%20epic%20scale&width=600&height=800&seq=anime-cover-15&orientation=portrait',
    description: '107年前，世界上突然出现了人类的天敌「巨人」。面临着生存危机而残存下来的人类逃到了一个地方，盖起了三重巨大的城墙。人们在这隔绝的环境里享受了一百多年的和平，直到艾伦·耶格尔十岁那年，60米高的「超大型巨人」突然出现，以压倒性的力量破坏城门，巨人们成群的冲进墙内捕食人类。',
    category: '日漫',
    rating: 9.9,
    episodes: 87,
    status: '已完结',
    tags: ['热血', '战斗', '悬疑', '末世'],
    author: '谏山创',
    year: 2013,
    views: '25.3亿',
    updatedAt: '2024-06-01',
    isHot: false,
    isNew: false,
  },
  {
    id: 'one-punch-man',
    title: '一拳超人',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20bald%20man%20in%20yellow%20superhero%20costume%20with%20red%20gloves%2C%20simple%20face%20expression%2C%20punching%20pose%2C%20comedy%20action%20Japanese%20anime%20style%2C%20bright%20vibrant%20colors&width=600&height=800&seq=anime-cover-16&orientation=portrait',
    description: '主人公埼玉原本是一名整日奔波于求职的普通人。三年前偶然遇到了要对淘气少年下杀手的异变螃蟹人后，回忆起年少年时"想要成为英雄"的梦想，最终拼尽全力救下了淘气少年。之后通过拼命锻炼，埼玉终于脱胎换骨获得了最强的力量，但同时失去了头发成了光头。由于力量太强，他面对的敌人都是一拳秒杀。',
    category: '日漫',
    rating: 9.6,
    episodes: 24,
    status: '连载中',
    tags: ['搞笑', '热血', '战斗', '超级英雄'],
    author: 'ONE',
    year: 2015,
    views: '16.7亿',
    updatedAt: '2024-07-25',
    isHot: false,
    isNew: false,
  },
  {
    id: 'under-one-person',
    title: '一人之下',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20of%20a%20young%20man%20with%20supernatural%20powers%2C%20glowing%20eyes%2C%20surrounded%20by%20talismans%20and%20mystical%20symbols%2C%20urban%20fantasy%20setting%2C%20dynamic%20action&width=600&height=800&seq=anime-cover-17&orientation=portrait',
    description: '平凡大学生张楚岚，因为爷爷坟墓被盗而回到家乡。在调查过程中，他遇到了一位神秘少女冯宝宝。由此，张楚岚被卷入了一个充满异人的世界。在这个世界里，各种身怀绝技的异人层出不穷，而张楚岚也逐渐发现自己身上隐藏的秘密——他其实是异人界传说中的"炁体源流"的传承者。',
    category: '国漫',
    rating: 9.5,
    episodes: 60,
    status: '连载中',
    tags: ['热血', '奇幻', '搞笑', '都市'],
    author: '米二',
    year: 2016,
    views: '9.8亿',
    updatedAt: '2024-07-28',
    isHot: false,
    isNew: false,
  },
  {
    id: 'lookism',
    title: '外貌至上主义',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20poster%20showing%20two%20contrasting%20figures%20of%20one%20person%20-%20one%20overweight%20and%20one%20handsome%2C%20school%20background%2C%20identity%20theme%2C%20dramatic%20split%20composition&width=600&height=800&seq=anime-cover-18&orientation=portrait',
    description: '朴亨锡是一个因为外貌和体型而饱受欺凌的高中生。某天，他意外发现自己拥有了两个身体——一个是他原本肥胖的身体，另一个则是完美帅气的身体。当一个身体在活动时，另一个就会陷入沉睡。通过这个新身体，亨锡经历了完全不同的人生，也看到了这个世界对"外貌"的残酷偏见。',
    category: '韩漫',
    rating: 9.3,
    episodes: 450,
    status: '连载中',
    tags: ['校园', '剧情', '励志', '社会'],
    author: '朴泰俊',
    year: 2022,
    views: '7.1亿',
    updatedAt: '2024-08-03',
    isHot: false,
    isNew: false,
  },
  {
    id: 'grandmaster-of-demonic-cultivation',
    title: '陈情令',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20poster%20of%20two%20swordsmen%20in%20white%20and%20black%20traditional%20robes%2C%20bamboo%20forest%20background%2C%20moonlight%2C%20swords%20drawn%2C%20elegant%20ink%20wash%20painting%20style&width=600&height=800&seq=anime-cover-19&orientation=portrait',
    description: '十六年前，天下五分，姑苏蓝氏、云梦江氏、清河聂氏、岐山温氏、兰陵金氏共治天下。温氏一家独大，横行霸道，众仙门深受其害。云梦江氏故人之子魏无羡与姑苏蓝氏含光君蓝忘机相识相知，共同锄奸扶弱。然而，随着真相一步步被揭开，一场惊天阴谋也浮出水面。',
    category: '国漫',
    rating: 9.7,
    episodes: 23,
    status: '已完结',
    tags: ['仙侠', '耽美', '悬疑', '玄幻'],
    author: '墨香铜臭',
    year: 2019,
    views: '13.2亿',
    updatedAt: '2024-04-15',
    isHot: false,
    isNew: false,
  },
  {
    id: 'naruto-shippuden',
    title: '火影忍者疾风传',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20ninja%20boy%20with%20yellow%20spiky%20hair%20in%20orange%20outfit%2C%20shadow%20clone%20technique%2C%20ninja%20village%20background%2C%20classic%20Japanese%20anime%20art%20style%2C%20dynamic%20action%20pose&width=600&height=800&seq=anime-cover-20&orientation=portrait',
    description: '修行两年半后，鸣人结束了与自来也的训练回到了木叶忍者村。此时的他与伙伴们都已经成长为更加强大的忍者，但「晓」的威胁依然存在。为了追回挚友佐助，为了保护木叶村，鸣人与他的伙伴们将面对前所未有的挑战。在忍界大战的硝烟中，鸣人一步步迈向火影的梦想。',
    category: '日漫',
    rating: 9.8,
    episodes: 500,
    status: '已完结',
    tags: ['热血', '忍者', '友情', '战斗'],
    author: '岸本齐史',
    year: 2007,
    views: '30.5亿',
    updatedAt: '2024-03-20',
    isHot: false,
    isNew: false,
  },
];

export const banners: { id: string; image: string; title: string; link: string }[] = [
  {
    id: 'banner-1',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20banner%20featuring%20multiple%20popular%20anime%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20colors%2C%20cinematic%20lighting%2C%20Japanese%20anime%20style%20illustration%2C%20dramatic%20composition%2C%20warm%20orange%20and%20red%20color%20scheme&width=1600&height=600&seq=banner-hero-01&orientation=landscape',
    title: '热门推荐：鬼灭之刃',
    link: '/anime/kimetsu-no-yaiba',
  },
  {
    id: 'banner-2',
    image: 'https://readdy.ai/api/search-image?query=Anime%20banner%20showcasing%20a%20powerful%20warrior%20with%20glowing%20energy%20surrounded%20by%20shadow%20soldiers%2C%20dark%20fantasy%20theme%2C%20Korean%20manhwa%20art%20style%2C%20epic%20scale%2C%20purple%20and%20black%20atmosphere&width=1600&height=600&seq=banner-hero-02&orientation=landscape',
    title: '口碑神作：我独自升级',
    link: '/anime/solo-leveling',
  },
  {
    id: 'banner-3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20banner%20featuring%20elegant%20cultivators%20flying%20among%20clouds%20and%20magical%20palaces%2C%20traditional%20Chinese%20aesthetic%2C%20fantasy%20landscape%2C%20warm%20golden%20and%20jade%20color%20scheme&width=1600&height=600&seq=banner-hero-03&orientation=landscape',
    title: '国漫精选：天官赐福',
    link: '/anime/tian-guan-ci-fu',
  },
];

export const categories = ['日漫', '韩漫', '国漫'] as const;